/* A run of occurrences drawn as cells — one per day or per answer — and the three drawings a cell
 * can wear: done (a quiet fill), missed (an outline in the danger ink), free (a dashed edge: nothing
 * was asked). Promoted out of `pages/client-detail/ui/DetailTab.module.css` on 4 November 2026 on
 * its second consumer, `features/survey-report`'s chart strip, which draws a two-option question's
 * answers with the same cells. The surface states the cell's place and nothing it draws. */

.cells {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr);
  gap: var(--space-1);
  padding: var(--space-0);
  margin: var(--space-0);
  list-style: none;
}

.cell {
  position: relative;
  display: block;
  height: var(--h-sess-cell);
  border-radius: var(--radius-4px);
}

.cellDone {
  background: var(--text);
  opacity: var(--o-affordance-rest);
}

/* An OUTLINE, not a fill, and the same drawing `shared/ui/TrainingWeekStrip` gives a missed day —
 * the owner chose the outline over the canon's fill on 1 September 2026, having been shown both.
 * `--danger` is the canon's own colour; the hairline is what the strip's other outlines wear. */
.cellMissed {
  border: var(--border-hairline) solid var(--danger);
}

/* Nothing was asked on this day. Dashed rather than empty: an empty square and a missing square
 * look the same, and only one of them is a fact.
 *
 * `--border`, which is the canon's and is what `shared/ui/TrainingWeekStrip` — the same drawing on
 * the summary column and the roster panel — already wears. It stood at `--border-3` on a measured
 * departure: composited against `--bg-card`, `--border` gives 1.18:1 in Flame and 1.22:1 in Flame
 * Dark, so a third of the legend named a square that is invisible rather than faint. The owner
 * withdrew that argument on 1 September 2026; the measurement is in the round's report. */
.cellFree {
  border: var(--border-hairline) dashed var(--border);
}
